module.exports = __webpack_public_path__ + "img/vietnam.8a0beafd.svg";